import { Flame, Sparkles, BookOpen, Hand } from "lucide-react";
import { motion } from "framer-motion";
import { useLanguage } from "@/contexts/LanguageContext";

const ICONS = [Sparkles, Flame, Hand, BookOpen];

const WhyOrthodox = () => {
  const { t } = useLanguage();
  const items = t.why.items;

  return (
    <section
      id="why"
      className="relative py-24 lg:py-36 overflow-hidden"
      style={{ background: "#1A1A1C" }}
    >
      {/* Candlelight glow */}
      <div className="pointer-events-none absolute -top-32 left-1/2 -translate-x-1/2 w-[800px] h-[400px]" style={{ background: "radial-gradient(ellipse, rgba(198,156,34,0.18) 0%, transparent 60%)" }} />
      {/* Subtle gold grain texture */}
      <div className="pointer-events-none absolute inset-0 opacity-[0.04]" style={{ backgroundImage: "url(\"data:image/svg+xml;utf8,<svg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='2'/><feColorMatrix values='0 0 0 0 0.78 0 0 0 0 0.61 0 0 0 0 0.13 0 0 0 1 0'/></filter><rect width='100%' height='100%' filter='url(%23n)'/></svg>\")" }} />

      <div className="container-boe relative">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.3em] font-semibold" style={{ color: "#E5C76B" }}>
            <span className="w-7 h-px bg-gold" /> {t.why.eyebrow}
          </span>
          <h2 className="mt-5 text-4xl md:text-5xl lg:text-6xl font-accent italic font-medium text-cream leading-[1.05] tracking-tight">
            {t.why.title}
          </h2>
          <p className="mt-6 text-lg text-cream/75 max-w-2xl leading-relaxed">{t.why.intro}</p>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-5 lg:gap-6">
          {items.map((item, i) => {
            const Icon = ICONS[i];
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.55, delay: (i % 2) * 0.1 }}
                className="group relative overflow-hidden rounded-3xl border border-gold/20 bg-white/[0.03] backdrop-blur-sm p-8 lg:p-10 transition-all duration-500 hover:border-gold/50 hover:bg-white/[0.06]"
              >
                <div className="flex items-start gap-5">
                  <div className="flex-shrink-0 w-12 h-12 rounded-2xl border border-gold/40 flex items-center justify-center" style={{ background: "rgba(198,156,34,0.1)" }}>
                    <Icon size={20} strokeWidth={1.6} style={{ color: "#E5C76B" }} />
                  </div>
                  <div>
                    <h3 className="font-accent italic text-3xl font-medium leading-tight mb-3" style={{ color: "#E5C76B" }}>
                      {item.title}
                    </h3>
                    <p className="text-cream/80 leading-relaxed text-[15px]">{item.desc}</p>
                  </div>
                </div>
              </motion.div>
            );
          })}
        </div>

        <div className="mt-16 text-center">
          <div className="ornate-divider mb-6" style={{ color: "#E5C76B" }} />
          <p className="font-accent italic text-xl md:text-2xl text-gold-soft max-w-2xl mx-auto leading-relaxed" style={{ color: "#E5C76B" }}>
            {t.why.footer}
          </p>
        </div>
      </div>
    </section>
  );
};

export default WhyOrthodox;
